(function () {
  'use strict';

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme && theme.money_format) {
      return Shopify.formatMoney(cents, theme.money_format);
    }
    return '£' + (Number(cents || 0) / 100).toFixed(2);
  }

  var COLOUR_FAMILIES = [
    { key: 'black', aliases: ['black', 'ebony', 'night'] },
    { key: 'turquoise', aliases: ['aqua', 'aquamarine', 'teal', 'turquoise', 'mint', 'petrol'] },
    { key: 'blue', aliases: ['blue', 'navy', 'indigo', 'sky', 'duck egg'] },
    { key: 'red', aliases: ['red', 'scarlet', 'garnet', 'burgundy', 'cherry', 'currant', 'poppy'] },
    { key: 'pink', aliases: ['pink', 'blush', 'rose', 'raspberry', 'fuchsia'] },
    { key: 'green', aliases: ['green', 'sage', 'dusk', 'olive', 'seagrass', 'vetiver'] },
    { key: 'purple', aliases: ['purple', 'violet', 'plum', 'orchid', 'lavender'] },
    { key: 'brown', aliases: ['brown', 'cognac', 'chestnut', 'walnut', 'espresso', 'mocha'] },
    { key: 'beige', aliases: ['beige', 'oat', 'stone', 'almond', 'nude', 'fawn', 'taupe'] },
    { key: 'grey', aliases: ['grey', 'gray', 'granite', 'silver', 'charcoal', 'concrete'] },
    { key: 'yellow', aliases: ['yellow', 'lemon'] },
    { key: 'gold', aliases: ['ochre', 'mustard', 'gold'] },
    { key: 'white', aliases: ['white', 'snow', 'ivory'] }
  ];

  function normaliseColour(value) {
    var normalised = String(value || '').toLowerCase();
    if (normalised.normalize) normalised = normalised.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return normalised.replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function containsColourAlias(value, alias) {
    return (' ' + value + ' ').indexOf(' ' + alias + ' ') !== -1;
  }

  function colourKeys(value) {
    var keys = [];
    String(value || '').split('|').forEach(function (part) {
      var normalised = normaliseColour(part);
      if (!normalised) return;
      var family = COLOUR_FAMILIES.find(function (item) {
        return item.aliases.some(function (alias) { return containsColourAlias(normalised, alias); });
      });
      var key = family ? family.key : normalised;
      if (keys.indexOf(key) === -1) keys.push(key);
    });
    return keys;
  }

  function colourValuesMatch(cardValue, filterValue) {
    var cardKeys = colourKeys(cardValue);
    var filterKeys = colourKeys(filterValue);
    return filterKeys.some(function (key) { return cardKeys.indexOf(key) !== -1; });
  }

  function uniqueProductCards(nodes) {
    var seenProducts = Object.create(null);
    return Array.prototype.slice.call(nodes).filter(function (card) {
      var productId = String(card.dataset.productId || '');
      if (!productId) return true;
      if (seenProducts[productId]) {
        card.remove();
        return false;
      }
      seenProducts[productId] = true;
      return true;
    });
  }

  function activateBundleGallery(root, key) {
    var template = key ? (root.querySelector('[data-lj-gallery-template="' + key + '"]') || root.querySelector('[data-lj-gallery-template="baby"]')) : null;
    var gallery = root.querySelector('[data-lj-product-gallery]');
    if (template && gallery && template.content && template.content.firstElementChild) {
      gallery.replaceWith(template.content.firstElementChild.cloneNode(true));
    }

    if (window.theme && typeof window.theme.initProductGallery === 'function') {
      window.theme.initProductGallery(root);
    }
  }

  function hydrateBundleJournal(root) {
    var dataNode = root.querySelector('[data-lj-journal-products]');
    if (!dataNode) {
      activateBundleGallery(root);
      return;
    }
    var catalogue;
    try {
      catalogue = JSON.parse(dataNode.textContent);
    } catch (error) {
      activateBundleGallery(root);
      return;
    }

    var key = new URLSearchParams(window.location.search).get('journal') || 'baby';
    if (!catalogue[key]) key = 'baby';
    var record = catalogue[key] || catalogue.baby;
    var product = record && record.product;
    var title = (record && record.display_title) || (product && product.title) || 'Baby Journal Refill';
    var banner = root.querySelector('[data-lj-journal-banner]');
    if (banner) {
      var bannerSource = banner.getAttribute('data-banner-' + key);
      if (bannerSource) banner.src = bannerSource;
      banner.alt = title + ' detail';
    }
    if (!product || !product.variants || !product.variants.length) {
      activateBundleGallery(root, key);
      return;
    }

    var variant = product.variants.find(function (item) { return item.available; }) || product.variants[0];
    root.dataset.refillVariantId = variant.id || 0;
    root.dataset.refillPrice = variant.price || product.price || 0;
    root.dataset.refillTitle = title;

    var titleNode = root.querySelector('[data-lj-refill-title]');
    var priceNode = root.querySelector('[data-lj-refill-price]');
    var skuNode = root.querySelector('[data-lj-refill-sku]');
    var descriptionNode = root.querySelector('[data-lj-refill-description]');
    if (titleNode) titleNode.textContent = title;
    if (priceNode) priceNode.textContent = money(variant.price || product.price || 0);
    if (skuNode) skuNode.textContent = 'SKU: ' + (variant.sku || '');
    if (descriptionNode && product.description) descriptionNode.innerHTML = product.description;
    activateBundleGallery(root, key);
  }

  function organiserPrintProperties(card, variantId) {
    var dataNode = card && card.querySelector('[data-lj-variant-properties]');
    if (!dataNode) return {};
    var selected;
    var pdfUrl;
    try {
      selected = JSON.parse(dataNode.textContent)[String(variantId)];
      pdfUrl = new URL(selected._PDF);
    } catch (error) {}
    if (!selected || typeof selected._PDF !== 'string' || !pdfUrl || !/^https?:$/.test(pdfUrl.protocol)) {
      throw new Error(dataNode.dataset.ljPrintError || 'Unable to add this bundle to the basket.');
    }
    var properties = { _PDF: selected._PDF };
    if (selected['_Interior Colour']) properties['_Interior Colour'] = selected['_Interior Colour'];
    return properties;
  }

  function postCart(items) {
    return fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          throw new Error(body.description || body.message || 'Unable to add this item to the basket.');
        });
      }
      return response.json();
    });
  }

  function notifyCartChanged() {
    document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {
      bubbles: true,
      cancelable: false
    }));
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read the basket.');
      return response.json();
    });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update the basket.');
      return response.json();
    });
  }

  function standaloneOfferFromResponse(response, variantId, price, title) {
    var responseItem = response && Array.isArray(response.items) ? response.items[0] : response;
    return {
      variantId: Number(variantId),
      price: Number(price),
      title: title || 'Lifestyle Journal Refill',
      lineKey: responseItem && responseItem.key ? String(responseItem.key) : ''
    };
  }

  function addDiscountedSecondRefill(offer, second) {
    if (!offer || !offer.variantId || !second || !second.variantId) {
      return Promise.reject(new Error('Please choose an available Lifestyle Journal Refill.'));
    }

    var bundleId = 'lj_pair_' + Date.now() + '_' + Math.round(Math.random() * 1000000);
    var secondNow = Math.round(second.price * 0.85);
    var bundleWas = offer.price + second.price;
    var bundleNow = offer.price + secondNow;
    var discount = bundleWas > 0 ? Number((((bundleWas - bundleNow) / bundleWas) * 100).toFixed(4)) : 0;

    function isStandaloneFirst(item) {
      var properties = item.properties || {};
      var components = item.item_components || [];
      var originalPrice = Number(item.original_price || item.price || 0);
      var matchesAddedLine = offer.lineKey ? String(item.key || '') === offer.lineKey : Object.keys(properties).length === 0;
      return Number(item.id || item.variant_id) === offer.variantId &&
        originalPrice === offer.price &&
        components.length === 0 &&
        !properties._bundleId &&
        matchesAddedLine;
    }

    function componentRole(component) {
      return String((component.properties || {})._role || '');
    }

    function isOfferPair(item) {
      var components = item.item_components || [];
      if (Number(item.id || item.variant_id) !== offer.variantId) return false;
      if (components.length < 2) {
        return Number(item.original_price || item.price || 0) === bundleNow;
      }
      var hasFirst = components.some(function (component) {
        return componentRole(component) === 'main' && Number(component.id || component.variant_id) === offer.variantId;
      });
      var hasSecond = components.some(function (component) {
        return componentRole(component) === 'half' && Number(component.id || component.variant_id) === second.variantId;
      });
      return hasFirst && hasSecond;
    }

    var pairAdded = false;
    var pairQuantityBefore = 0;

    function pairQuantity(cart) {
      return (cart.items || []).filter(isOfferPair).reduce(function (total, item) {
        return total + Number(item.quantity || 0);
      }, 0);
    }

    function removeRawBundleLines(cart) {
      var rawLines = [];
      (cart.items || []).forEach(function (item, index) {
        if (String((item.properties || {})._bundleId || '') === bundleId) rawLines.push(index + 1);
      });
      rawLines.sort(function (a, b) { return b - a; });
      return rawLines.reduce(function (promise, line) {
        return promise.then(function () { return changeCartLine(line, 0); });
      }, Promise.resolve(cart));
    }

    function rollbackOffer() {
      return getCart().then(function (cart) {
        return removeRawBundleLines(cart);
      }).then(function () {
        return getCart();
      }).then(function (cart) {
        var pairQuantityNow = pairQuantity(cart);
        if (pairQuantityNow <= pairQuantityBefore) return cart;
        var pairIndex = (cart.items || []).findIndex(isOfferPair);
        if (pairIndex < 0) return cart;
        var pair = cart.items[pairIndex];
        return changeCartLine(pairIndex + 1, Math.max(0, Number(pair.quantity || 1) - 1));
      });
    }

    return getCart().then(function (cart) {
      var firstLine = (cart.items || []).find(function (item) {
        return isStandaloneFirst(item);
      });

      if (!firstLine || Number(firstLine.quantity || 0) < 1) {
        throw new Error('Your first Lifestyle Journal Refill is no longer in the basket.');
      }
      pairQuantityBefore = pairQuantity(cart);

      return postCart([
        {
          id: offer.variantId,
          quantity: 1,
          properties: {
            _bundleId: bundleId,
            _parent: offer.variantId,
            _role: 'main',
            _discount: discount,
            _orig_cents: offer.price,
            _now_cents: offer.price,
            _bundle_type: 'lifestyle-journal',
            _bundle_label: offer.title + ' + ' + second.title
          }
        },
        {
          id: second.variantId,
          quantity: 1,
          properties: {
            _bundleId: bundleId,
            _parent: offer.variantId,
            _role: 'half',
            _discount: discount,
            _orig_cents: second.price,
            _now_cents: secondNow,
            _title: second.title,
            _bundle_type: 'lifestyle-journal-refill',
            _offer_percent: 15,
            _bundle_parent_variant: String(offer.variantId),
            _bundle_label: '15% off second Lifestyle Journal Refill'
          }
        }
      ]).then(function () {
        pairAdded = true;
        return getCart();
      }).then(function (updatedCart) {
        if (pairQuantity(updatedCart) <= pairQuantityBefore) {
          throw new Error('The 15% refill offer could not be applied. Your first refill is still in the basket at full price.');
        }
        var firstIndex = (updatedCart.items || []).findIndex(isStandaloneFirst);
        if (firstIndex < 0) throw new Error('The full-price refill could not be linked to this offer.');
        var standalone = updatedCart.items[firstIndex];
        return changeCartLine(firstIndex + 1, Math.max(0, Number(standalone.quantity || 1) - 1));
      }).catch(function (error) {
        if (!pairAdded) throw error;
        return rollbackOffer().catch(function () {}).then(function () { throw error; });
      });
    });
  }

  function addSecondRefillToOrganiserBundle(offer, second) {
    if (!offer || !offer.organiserVariantId || !offer.firstVariantId || !second || !second.variantId) {
      return Promise.reject(new Error('Please choose an available Lifestyle Journal Refill.'));
    }

    var firstQuantity = Math.max(1, Number(offer.firstQuantity || 1));
    var firstNow = Math.round(offer.firstPrice * 0.85);
    var secondNow = Math.round(second.price * 0.85);
    var oldUnitPrice = Number(offer.unitPrice || (offer.organiserPrice + (firstNow * firstQuantity)));
    var bundleWas = offer.organiserPrice + (offer.firstPrice * firstQuantity) + second.price;
    var bundleNow = offer.organiserPrice + (firstNow * firstQuantity) + secondNow;
    var discount = bundleWas > 0 ? Number((((bundleWas - bundleNow) / bundleWas) * 100).toFixed(4)) : 0;
    var replacementBundleId = 'lj_' + Date.now() + '_' + Math.round(Math.random() * 1000000);
    var oldQuantityBefore = 0;
    var newQuantityBefore = 0;
    var replacementAttempted = false;
    var replacementUnitPrice = 0;
    var organiserCountsBefore = Object.create(null);
    var originalLineKey = null;
    var replacementLineKey = null;

    function itemUnitPrice(item) {
      return Number(item.original_price || item.price || 0);
    }

    function mainProperties(item) {
      var component = (item.item_components || []).find(function (entry) {
        return Number(entry.id || entry.variant_id) === Number(offer.organiserVariantId) &&
          String((entry.properties || {})._role || '') === 'main';
      });
      var source = component || (!item.has_components && String((item.properties || {})._role || '') === 'main' ? item : null);
      var properties = Object.assign({}, source && source.properties || {});
      delete properties._filofax_sticker_bundle_v1;
      delete properties._filofax_sticker_bridge_probe_v1;
      return properties;
    }

    function bundleIdentity(item) {
      var directId = mainProperties(item)._bundleId;
      if (directId) return String(directId);
      try {
        var marker = JSON.parse((item.properties || {})._filofax_sticker_bundle_v1 || 'null');
        if (marker && marker.v === 1 && typeof marker.b === 'string') return marker.b;
      } catch (error) {}
      return '';
    }

    function matchesSignature(item, unitPrice) {
      return Number(item.id || item.variant_id) === Number(offer.organiserVariantId) && itemUnitPrice(item) === unitPrice;
    }

    function signatureQuantity(cart, unitPrice) {
      return (cart.items || []).filter(function (item) {
        return matchesSignature(item, unitPrice);
      }).reduce(function (total, item) {
        return total + Number(item.quantity || 0);
      }, 0);
    }

    function signatureLine(cart, unitPrice, lineKey) {
      var index = (cart.items || []).findIndex(function (item) {
        return matchesSignature(item, unitPrice) && Number(item.quantity || 0) > 0 &&
          (!lineKey || item.key === lineKey);
      });
      if (index < 0) return null;
      return { index: index, item: cart.items[index] };
    }

    function organiserSignatureCounts(cart) {
      var counts = Object.create(null);
      (cart.items || []).forEach(function (item) {
        if (Number(item.id || item.variant_id) !== Number(offer.organiserVariantId)) return;
        var unitPrice = String(itemUnitPrice(item));
        counts[unitPrice] = Number(counts[unitPrice] || 0) + Number(item.quantity || 0);
      });
      return counts;
    }

    function increasedOrganiserUnitPrice(cart) {
      var currentCounts = organiserSignatureCounts(cart);
      var preferredPrices = [replacementUnitPrice, bundleNow].filter(function (price, index, prices) {
        return price > 0 && prices.indexOf(price) === index;
      });
      var increased = preferredPrices.find(function (price) {
        return Number(currentCounts[String(price)] || 0) > Number(organiserCountsBefore[String(price)] || 0);
      });
      if (increased) return Number(increased);
      var changedPrice = Object.keys(currentCounts).find(function (price) {
        return Number(currentCounts[price] || 0) > Number(organiserCountsBefore[price] || 0);
      });
      return Number(changedPrice || 0);
    }

    function organiserCountsMatchBaseline(cart) {
      var currentCounts = organiserSignatureCounts(cart);
      var allPrices = Object.keys(organiserCountsBefore).concat(Object.keys(currentCounts)).filter(function (price, index, prices) {
        return prices.indexOf(price) === index;
      });
      return allPrices.every(function (price) {
        return Number(currentCounts[price] || 0) === Number(organiserCountsBefore[price] || 0);
      });
    }

    function upgradeIsComplete(cart) {
      return signatureQuantity(cart, oldUnitPrice) <= oldQuantityBefore - 1 &&
        signatureQuantity(cart, bundleNow) >= newQuantityBefore + 1;
    }

    function removeRawReplacementLines(cart) {
      var rawLines = [];
      (cart.items || []).forEach(function (item, index) {
        if (String((item.properties || {})._bundleId || '') === replacementBundleId) rawLines.push(index + 1);
      });
      rawLines.sort(function (a, b) { return b - a; });
      return rawLines.reduce(function (promise, line) {
        return promise.then(function () { return changeCartLine(line, 0); });
      }, Promise.resolve(cart));
    }

    function rollbackReplacement(cart) {
      return removeRawReplacementLines(cart).then(function () {
        return getCart();
      }).then(function (updatedCart) {
        var rollbackUnitPrice = increasedOrganiserUnitPrice(updatedCart);
        if (!rollbackUnitPrice) return updatedCart;
        var replacementIndex = (updatedCart.items || []).findIndex(function (item) {
          return matchesSignature(item, rollbackUnitPrice) &&
            ((replacementLineKey && item.key === replacementLineKey) ||
              bundleIdentity(item) === replacementBundleId);
        });
        if (replacementIndex < 0) throw new Error('The replacement bundle could not be found for rollback.');
        var replacementLine = { index: replacementIndex, item: updatedCart.items[replacementIndex] };
        return changeCartLine(
          replacementLine.index + 1,
          Math.max(0, Number(replacementLine.item.quantity || 1) - 1)
        );
      }).then(function () {
        return getCart();
      }).then(function (updatedCart) {
        if (!organiserCountsMatchBaseline(updatedCart)) {
          throw new Error('The replacement bundle could not be rolled back.');
        }
        return updatedCart;
      });
    }

    return getCart().then(function (cart) {
      oldQuantityBefore = signatureQuantity(cart, oldUnitPrice);
      newQuantityBefore = signatureQuantity(cart, bundleNow);
      organiserCountsBefore = organiserSignatureCounts(cart);
      if (oldQuantityBefore < 1) {
        throw new Error('Your confirmed Lifestyle Journal Refill Bundle is no longer in the basket.');
      }

      var originalBundles = (cart.items || []).filter(function (item) {
        return matchesSignature(item, oldUnitPrice) && Number(item.quantity || 0) > 0;
      });
      var originalBundle = originalBundles.find(function (item) {
        return offer.lineKey && item.key === offer.lineKey;
      }) || originalBundles.find(function (item) {
        return offer.bundleId && bundleIdentity(item) === String(offer.bundleId);
      }) || (originalBundles.length === 1 && !bundleIdentity(originalBundles[0]) ? originalBundles[0] : null);
      if (!originalBundle) throw new Error('Your original bundle could not be found.');
      originalLineKey = originalBundle.key || null;
      var organiserProperties = Object.assign({}, offer.organiserProperties || {}, mainProperties(originalBundle));

      replacementAttempted = true;
      return postCart([
        {
          id: offer.organiserVariantId,
          quantity: 1,
          properties: Object.assign({}, organiserProperties, {
            _bundleId: replacementBundleId,
            _parent: offer.organiserVariantId,
            _role: 'main',
            _discount: discount,
            _orig_cents: offer.organiserPrice,
            _now_cents: offer.organiserPrice,
            _bundle_type: 'lifestyle-journal',
            _bundle_label: offer.firstTitle + ' + ' + offer.organiserTitle + ' + ' + second.title
          })
        },
        {
          id: offer.firstVariantId,
          quantity: firstQuantity,
          properties: {
            _bundleId: replacementBundleId,
            _parent: offer.organiserVariantId,
            _role: 'first',
            _discount: discount,
            _orig_cents: offer.firstPrice,
            _now_cents: firstNow,
            _title: offer.firstTitle,
            _bundle_type: 'lifestyle-journal-refill',
            _offer_percent: 15,
            _bundle_parent_variant: String(offer.organiserVariantId),
            _bundle_label: '15% off Lifestyle Journal Refill'
          }
        },
        {
          id: second.variantId,
          quantity: 1,
          properties: {
            _bundleId: replacementBundleId,
            _parent: offer.organiserVariantId,
            _role: 'half',
            _discount: discount,
            _orig_cents: second.price,
            _now_cents: secondNow,
            _title: second.title,
            _bundle_type: 'lifestyle-journal-refill',
            _offer_percent: 15,
            _bundle_parent_variant: String(offer.organiserVariantId),
            _bundle_label: '15% off second Lifestyle Journal Refill'
          }
        }
      ]);
    }).then(function (response) {
      var responseItem = response && Array.isArray(response.items) ? response.items[0] : response;
      replacementUnitPrice = responseItem ? Number(responseItem.original_price || responseItem.price || 0) : 0;
      replacementLineKey = responseItem && responseItem.key ? responseItem.key : null;
      return getCart();
    }).then(function (cart) {
      replacementUnitPrice = increasedOrganiserUnitPrice(cart);
      if (replacementUnitPrice !== bundleNow || signatureQuantity(cart, bundleNow) <= newQuantityBefore) {
        throw new Error('The second refill could not be added to your bundle.');
      }
      var oldLine = signatureLine(cart, oldUnitPrice, originalLineKey);
      if (!oldLine) throw new Error('Your original bundle could not be found.');
      return changeCartLine(oldLine.index + 1, Math.max(0, Number(oldLine.item.quantity || 1) - 1));
    }).then(function () {
      return getCart();
    }).then(function (cart) {
      if (!upgradeIsComplete(cart)) throw new Error('The original bundle could not be replaced safely.');
      return cart;
    }).catch(function (error) {
      if (!replacementAttempted) throw error;
      return getCart().then(function (cart) {
        if (upgradeIsComplete(cart)) return cart;
        return rollbackReplacement(cart).then(function () {
          throw error;
        }).catch(function (rollbackError) {
          if (rollbackError === error) throw error;
          throw new Error('The second refill could not be added safely. Please review your basket before trying again.');
        });
      }, function () {
        throw error;
      });
    });
  }

  function openModal(modal, copyMode) {
    if (!modal) return;
    modal.querySelectorAll('[data-lj-modal-copy]').forEach(function (copy) {
      copy.hidden = copy.dataset.ljModalCopy !== copyMode;
    });
    var title = modal.querySelector('[data-lj-modal-title]');
    if (title) {
      var titleText = copyMode === 'bundle' ? title.dataset.ljTitleBundle : title.dataset.ljTitleRefillOnly;
      if (titleText) title.textContent = titleText;
    }
    var modalStatus = modal.querySelector('[data-lj-modal-status]');
    if (modalStatus) modalStatus.textContent = '';
    modal.dataset.ljModalMode = copyMode || '';
    modal.hidden = false;
    document.body.classList.add('lj-modal-open');
    var close = modal.querySelector('[data-lj-modal-close]');
    if (close) close.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('lj-modal-open');
  }

  function initQuantity(root) {
    root.querySelectorAll('[data-lj-quantity]').forEach(function (quantity) {
      var input = quantity.querySelector('input');
      quantity.addEventListener('click', function (event) {
        var button = event.target.closest('button');
        if (!button || !input) return;
        var value = Math.max(1, Number(input.value || 1));
        input.value = button.dataset.ljQuantity === 'minus' ? Math.max(1, value - 1) : value + 1;
      });
    });
  }

  function initModal(root) {
    var modal = root.querySelector('[data-lj-modal]');
    if (!modal) return null;
    modal.addEventListener('click', function (event) {
      if ((event.target === modal || event.target.closest('[data-lj-modal-close]')) && modal.dataset.ljAddingSecond !== 'true') {
        closeModal(modal);
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden && modal.dataset.ljAddingSecond !== 'true') closeModal(modal);
    });
    return modal;
  }

  function initStory(root) {
    var slider = root.querySelector('[data-lj-story]');
    if (!slider) return;
    var track = slider.querySelector('[data-lj-story-track]');
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-lj-story-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-lj-story-dot]'));
    var previous = slider.querySelector('[data-lj-story-prev]');
    var next = slider.querySelector('[data-lj-story-next]');
    var active = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));

    function show(index) {
      active = (index + slides.length) % slides.length;
      if (track) track.style.transform = 'translateX(-' + (active * 100) + '%)';
      slides.forEach(function (slide, slideIndex) {
        var selected = slideIndex === active;
        var link = slide.querySelector('[data-lj-story-link]');
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        if (link) link.tabIndex = selected ? 0 : -1;
      });
      dots.forEach(function (dot, dotIndex) {
        var selected = dotIndex === active;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    if (previous) previous.addEventListener('click', function () { show(active - 1); });
    if (next) next.addEventListener('click', function () { show(active + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { show(Number(dot.dataset.ljStoryDot || 0)); });
    });
    show(active);
  }

  function initBundle(root) {
    var modal = initModal(root);
    if (window.matchMedia('(max-width: 720px)').matches) {
      root.querySelectorAll('[data-lj-mobile-collapsed]').forEach(function (details) {
        details.open = false;
      });
    }
    var refillVariantId = Number(root.dataset.refillVariantId || 0);
    var refillPrice = Number(root.dataset.refillPrice || 0);
    var refillTitle = root.dataset.refillTitle || 'Lifestyle Journal Refill';
    var quantityInput = root.querySelector('[data-lj-refill-quantity]');
    var refillOnlyButton = root.querySelector('[data-lj-add-refill-only]');
    var scrollBuilderButton = root.querySelector('[data-lj-scroll-builder]');
    var builder = root.querySelector('#lifestyle-journal-builder') || root.querySelector('.lj-builder');
    var builderTitle = root.querySelector('[data-lj-builder-title]');
    var confirmModal = root.querySelector('[data-lj-bundle-confirm]');
    var confirmRefill = confirmModal && confirmModal.querySelector('[data-lj-confirm-refill]');
    var confirmOrganiser = confirmModal && confirmModal.querySelector('[data-lj-confirm-organiser]');
    var confirmAddButton = confirmModal && confirmModal.querySelector('[data-lj-confirm-add]');
    var confirmCancelButtons = confirmModal ? Array.prototype.slice.call(confirmModal.querySelectorAll('[data-lj-confirm-cancel]')) : [];
    var confirmStatus = confirmModal && confirmModal.querySelector('[data-lj-confirm-status]');
    var status = root.querySelector('[data-lj-status]');
    var cards = uniqueProductCards(root.querySelectorAll('[data-lj-organiser-card]'));
    var organiserGrid = root.querySelector('[data-lj-organiser-grid]');
    var empty = root.querySelector('[data-lj-empty-filter]');
    var pagination = root.querySelector('[data-lj-pagination]');
    var pageSize = Math.max(1, Number(pagination && pagination.dataset.pageSize || 8));
    var currentPage = 1;
    var activePrice = null;
    var activeColour = '';
    var colourButtons = Array.prototype.slice.call(root.querySelectorAll('[data-colour-filter]'));
    var selectedOrganiser = null;
    var standaloneOffer = null;
    var organiserBundleOffer = null;
    var purchaseInFlight = false;
    var confirmReturnFocus = null;

    var modalParams = new URLSearchParams(window.location.search);
    if (modal && modalParams.get('lj-modal') === 'preview') {
      openModal(modal, modalParams.get('lj-modal-copy') === 'refill-only' ? 'refill-only' : 'bundle');
    }

    function report(message, type) {
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-warning', type === 'warning');
    }

    function setConfirmStatus(message) {
      if (!confirmStatus) return;
      confirmStatus.textContent = message || '';
    }

    function setPurchaseBusy(busy, activeButton) {
      purchaseInFlight = !!busy;
      [refillOnlyButton, scrollBuilderButton, confirmAddButton].concat(confirmCancelButtons).forEach(function (button) {
        if (!button) return;
        button.disabled = !!busy;
      });
      if (!activeButton) return;
      if (busy) {
        activeButton.dataset.ljPurchaseLabel = activeButton.textContent;
        activeButton.textContent = 'ADDING…';
        activeButton.setAttribute('aria-busy', 'true');
      } else {
        activeButton.textContent = activeButton.dataset.ljPurchaseLabel || activeButton.textContent;
        activeButton.removeAttribute('aria-busy');
        delete activeButton.dataset.ljPurchaseLabel;
      }
    }

    function confirmFocusableElements() {
      if (!confirmModal) return [];
      return Array.prototype.slice.call(confirmModal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return !element.hidden && element.getAttribute('aria-hidden') !== 'true';
      });
    }

    function closeBundleConfirmation(options) {
      options = options || {};
      if (!confirmModal || confirmModal.hidden) return;
      confirmModal.hidden = true;
      if (!options.keepBodyLocked) document.body.classList.remove('lj-modal-open');
      setConfirmStatus('');
      if (options.restoreFocus !== false && confirmReturnFocus && document.contains(confirmReturnFocus)) {
        confirmReturnFocus.focus();
      }
      confirmReturnFocus = null;
    }

    function updateBundleConfirmation() {
      if (!selectedOrganiser) return false;
      var organiserVariantId = Number(selectedOrganiser.dataset.variantId || 0);
      if (!organiserVariantId || !cardIsAvailable(selectedOrganiser)) return false;

      var organiserTitle = selectedOrganiser.dataset.title || 'A5 Organiser';
      var organiserColour = selectedOrganiser.dataset.selectedColour || '';
      if (confirmRefill) {
        confirmRefill.textContent = refillTitle;
      }
      if (confirmOrganiser) {
        confirmOrganiser.textContent = organiserTitle + (organiserColour ? ' in ' + organiserColour : '');
      }
      return true;
    }

    function openBundleConfirmation(trigger) {
      if (!confirmModal || purchaseInFlight) return;
      if (!updateBundleConfirmation()) {
        report('Please select an available organiser colour.');
        return;
      }
      confirmReturnFocus = trigger || document.activeElement;
      setConfirmStatus('');
      confirmModal.hidden = false;
      document.body.classList.add('lj-modal-open');
      var focusable = confirmFocusableElements();
      var target = confirmAddButton && !confirmAddButton.disabled ? confirmAddButton : focusable[0];
      if (target) target.focus();
    }

    if (confirmModal) {
      confirmModal.addEventListener('click', function (event) {
        if (event.target === confirmModal || event.target.closest('[data-lj-confirm-cancel]')) {
          event.preventDefault();
          if (!purchaseInFlight) closeBundleConfirmation();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (confirmModal.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          if (!purchaseInFlight) closeBundleConfirmation();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusable = confirmFocusableElements();
        if (!focusable.length) {
          event.preventDefault();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!confirmModal.contains(document.activeElement)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        } else if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    if (modal) {
      modal.addEventListener('click', function (event) {
        var link = event.target.closest('[data-lj-second-refill]');
        if (!link || !modal.contains(link)) return;
        var modalMode = modal.dataset.ljModalMode;
        var activeOffer = modalMode === 'refill-only' ? standaloneOffer : (modalMode === 'bundle' ? organiserBundleOffer : null);
        if (!activeOffer) return;
        event.preventDefault();
        if (modal.dataset.ljAddingSecond === 'true') return;

        var second = {
          variantId: Number(link.dataset.variantId || 0),
          price: Number(link.dataset.price || 0),
          title: link.dataset.title || link.textContent.trim()
        };
        if (link.dataset.available === 'false' || !second.variantId || !second.price) {
          var unavailableStatus = modal.querySelector('[data-lj-modal-status]');
          if (unavailableStatus) unavailableStatus.textContent = 'Sorry, this Lifestyle Journal Refill is currently unavailable.';
          return;
        }

        var modalStatus = modal.querySelector('[data-lj-modal-status]');
        var modalClose = modal.querySelector('[data-lj-modal-close]');
        var label = link.querySelector('span');
        var originalLabel = label ? label.textContent : '';
        modal.dataset.ljAddingSecond = 'true';
        modal.classList.add('is-adding');
        modal.setAttribute('aria-busy', 'true');
        if (modalClose) modalClose.disabled = true;
        link.classList.add('is-adding');
        link.setAttribute('aria-busy', 'true');
        if (label) label.textContent = 'ADDING…';
        if (modalStatus) modalStatus.textContent = 'Adding your second Lifestyle Journal refill…';

        var addSecond = modalMode === 'bundle'
          ? addSecondRefillToOrganiserBundle(organiserBundleOffer, second)
          : addDiscountedSecondRefill(standaloneOffer, second);

        addSecond.then(function () {
          if (modalMode === 'bundle') organiserBundleOffer = null;
          else standaloneOffer = null;
          notifyCartChanged();
          document.dispatchEvent(new CustomEvent('lj:cart:add', {
            detail: {
              discountedSecondRefill: true,
              organiserBundleExtended: modalMode === 'bundle'
            }
          }));
          window.location.assign((window.theme && theme.routes && theme.routes.cart_url) || '/cart');
        }).catch(function (error) {
          if (modalStatus) modalStatus.textContent = error.message || 'Sorry, the second refill could not be added. Please try again.';
        }).finally(function () {
          modal.dataset.ljAddingSecond = 'false';
          modal.classList.remove('is-adding');
          modal.removeAttribute('aria-busy');
          if (modalClose) modalClose.disabled = false;
          link.classList.remove('is-adding');
          link.removeAttribute('aria-busy');
          if (label) label.textContent = originalLabel;
        });
      });
    }

    function renderPagination(pageCount) {
      if (!pagination) return;
      pagination.innerHTML = '';
      pagination.hidden = pageCount <= 1;
      if (pageCount <= 1) return;

      function addPageButton(page, label, className) {
        var button = document.createElement('button');
        button.className = className || '';
        button.type = 'button';
        button.dataset.ljPage = page;
        button.textContent = label;
        if (page === currentPage) {
          button.setAttribute('aria-current', 'page');
          button.disabled = true;
        } else {
          button.setAttribute('aria-label', 'Show organiser page ' + page);
        }
        pagination.appendChild(button);
      }

      if (currentPage > 1) addPageButton(currentPage - 1, '<< Previous', 'lj-pagination__direction');
      for (var page = 1; page <= pageCount; page += 1) addPageButton(page, String(page));
      if (currentPage < pageCount) {
        var separator = document.createElement('span');
        separator.className = 'lj-pagination__separator';
        separator.textContent = '.';
        separator.setAttribute('aria-hidden', 'true');
        pagination.appendChild(separator);
        addPageButton(currentPage + 1, 'Next >>', 'lj-pagination__direction');
      }
    }

    function cardIsAvailable(card) {
      return card.dataset.available !== 'false';
    }

    function cardMatchesPrice(card) {
      if (!activePrice) return true;
      var colourSwatch = activeColour && getMatchingSwatch(card, activeColour);
      var price = Number((colourSwatch && colourSwatch.dataset.variantPrice) || card.dataset.variantPrice || card.dataset.price || 0);
      return price >= activePrice.min && (activePrice.max === null || price <= activePrice.max);
    }

    function cardColourValue(card) {
      var availableSwatches = Array.prototype.slice.call(card.querySelectorAll('[data-lj-card-swatch]')).filter(function (swatch) {
        return !swatch.disabled && swatch.getAttribute('aria-label');
      });
      var filterColours = card.dataset.filterColours || '';
      if (availableSwatches.length) {
        return availableSwatches.map(function (swatch) { return swatch.getAttribute('aria-label'); }).join('|') + (filterColours ? '|' + filterColours : '');
      }
      return filterColours || card.dataset.availableColours || card.dataset.colours || '';
    }

    function cardMatchesColour(card, colour) {
      return !colour || colourValuesMatch(cardColourValue(card), colour);
    }

    function getMatchingSwatch(card, colour) {
      return Array.prototype.slice.call(card.querySelectorAll('[data-lj-card-swatch]')).find(function (swatch) {
        return !swatch.disabled && colourValuesMatch(swatch.getAttribute('aria-label') || '', colour);
      });
    }

    function updateCardVariant(card, swatch) {
      if (!card || !swatch || swatch.disabled) return;

      card.querySelectorAll('[data-lj-card-swatch]').forEach(function (other) {
        var active = other === swatch;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      card.dataset.variantId = swatch.dataset.variantId || '';
      card.dataset.variantPrice = swatch.dataset.variantPrice || card.dataset.price;
      card.dataset.selectedColour = swatch.dataset.variantTitle || swatch.getAttribute('aria-label') || '';

      var image = card.querySelector('.lj-organiser-card__image img');
      var image320 = swatch.getAttribute('data-variant-image-320') || '';
      var image480 = swatch.getAttribute('data-variant-image-480') || '';
      var image700 = swatch.getAttribute('data-variant-image-700') || swatch.dataset.variantImage || '';
      if (image && image700) {
        image.src = image700;
        if (image320 && image480) {
          image.srcset = image320 + ' 320w, ' + image480 + ' 480w, ' + image700 + ' 700w';
          image.sizes = '(max-width: 720px) 50vw, 25vw';
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
        }
        image.alt = (card.dataset.title || '') + ' — ' + (swatch.dataset.variantTitle || swatch.getAttribute('aria-label') || '');
      }

      var variantUrl = swatch.dataset.variantUrl || '';
      var imageLink = card.querySelector('[data-lj-card-image-link]');
      var viewLink = card.querySelector('[data-lj-card-view]');
      if (variantUrl && imageLink) imageLink.href = variantUrl;
      if (variantUrl && viewLink) viewLink.href = variantUrl;

      var currentPrice = card.querySelector('[data-lj-card-current-price]');
      var comparePrice = card.querySelector('[data-lj-card-compare-price]');
      var sale = card.querySelector('[data-lj-card-sale]');
      var price = Number(swatch.dataset.variantPrice || 0);
      var compare = Number(swatch.dataset.variantComparePrice || 0);
      if (currentPrice) currentPrice.textContent = swatch.dataset.variantPriceDisplay || money(price);
      if (comparePrice) {
        comparePrice.hidden = compare <= price;
        comparePrice.textContent = compare > price ? (swatch.dataset.variantComparePriceDisplay || money(compare)) : '';
      }
      if (sale) sale.hidden = compare <= price;
    }

    function syncCardsToColour() {
      if (!activeColour) return;
      cards.forEach(function (card) {
        if (!cardIsAvailable(card) || !cardMatchesPrice(card) || !cardMatchesColour(card, activeColour)) return;
        var swatch = getMatchingSwatch(card, activeColour);
        if (swatch) updateCardVariant(card, swatch);
      });
    }

    function updateColourOptions() {
      colourButtons.forEach(function (button) {
        button.hidden = !cards.some(function (card) {
          return cardIsAvailable(card) && cardMatchesPrice(card) && cardMatchesColour(card, button.dataset.colourFilter || '');
        });
      });

      if (!activeColour) return;
      var activeButton = colourButtons.find(function (button) {
        return button.dataset.colourFilter === activeColour;
      });
      if (activeButton && !activeButton.hidden) return;
      activeColour = '';
      colourButtons.forEach(function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
    }

    function renderCards(shouldScroll) {
      var matchingCards = cards.filter(function (card) {
        return cardIsAvailable(card) && cardMatchesPrice(card) && cardMatchesColour(card, activeColour);
      });
      var pageCount = Math.ceil(matchingCards.length / pageSize);
      currentPage = Math.min(Math.max(1, currentPage), Math.max(1, pageCount));
      var pageStart = (currentPage - 1) * pageSize;
      var pageCards = matchingCards.slice(pageStart, pageStart + pageSize);
      cards.forEach(function (card) {
        card.hidden = pageCards.indexOf(card) === -1;
      });
      if (empty) empty.classList.toggle('is-visible', matchingCards.length === 0);
      renderPagination(pageCount);
      if (shouldScroll && organiserGrid) organiserGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function applyFilters(resetPage) {
      updateColourOptions();
      if (selectedOrganiser && !(cardIsAvailable(selectedOrganiser) && cardMatchesPrice(selectedOrganiser) && cardMatchesColour(selectedOrganiser, activeColour))) {
        selectOrganiser(null);
        report('');
      } else if (selectedOrganiser) {
        selectOrganiser(selectedOrganiser);
      }
      if (resetPage) currentPage = 1;
      renderCards(false);
    }

    if (pagination) {
      pagination.addEventListener('click', function (event) {
        var button = event.target.closest('[data-lj-page]');
        if (!button || button.disabled) return;
        if (selectedOrganiser) selectOrganiser(null);
        report('');
        currentPage = Number(button.dataset.ljPage || 1);
        renderCards(true);
      });
    }

    function selectOrganiser(card) {
      selectedOrganiser = card || null;
      cards.forEach(function (otherCard) {
        var otherButton = otherCard.querySelector('[data-lj-add-bundle]');
        var removeButton = otherCard.querySelector('[data-lj-remove-organiser]');
        var selected = otherCard === selectedOrganiser;
        var hasVariant = Number(otherCard.dataset.variantId || 0) > 0;
        var available = cardIsAvailable(otherCard);
        otherCard.classList.toggle('is-selected', selected);
        if (otherButton) {
          otherButton.disabled = !available || !hasVariant || (selectedOrganiser && !selected);
          otherButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
          otherButton.textContent = selected ? 'Selected' : 'Choose';
          otherButton.dataset.label = selected ? 'Selected' : 'Choose';
        }
        if (removeButton) removeButton.hidden = !selected;
      });
    }

    root.querySelectorAll('[data-filter-mode]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (selectedOrganiser) selectOrganiser(null);
        report('');
        var mode = tab.dataset.filterMode;
        root.querySelectorAll('[data-filter-mode]').forEach(function (other) {
          other.classList.toggle('is-active', other === tab);
          other.setAttribute('aria-pressed', other === tab ? 'true' : 'false');
        });
        root.querySelectorAll('[data-filter-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.filterPanel !== mode;
        });
      });
    });

    root.querySelectorAll('[data-price-min]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (selectedOrganiser) selectOrganiser(null);
        report('');
        var alreadyActive = button.classList.contains('is-active');
        activePrice = alreadyActive ? null : {
          min: Number(button.dataset.priceMin || 0),
          max: button.hasAttribute('data-price-max') ? Number(button.dataset.priceMax) : null
        };
        root.querySelectorAll('[data-price-min]').forEach(function (other) {
          other.classList.toggle('is-active', !alreadyActive && other === button);
          other.setAttribute('aria-pressed', !alreadyActive && other === button ? 'true' : 'false');
        });
        applyFilters(true);
      });
    });

    colourButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (selectedOrganiser) selectOrganiser(null);
        report('');
        var alreadyActive = button.classList.contains('is-active');
        activeColour = alreadyActive ? '' : (button.dataset.colourFilter || '');
        colourButtons.forEach(function (other) {
          other.classList.toggle('is-active', !alreadyActive && other === button);
          other.setAttribute('aria-pressed', !alreadyActive && other === button ? 'true' : 'false');
        });
        if (activeColour) syncCardsToColour();
        applyFilters(true);
      });
    });

    cards.forEach(function (card) {
      var addButton = card.querySelector('[data-lj-add-bundle]');
      var removeButton = card.querySelector('[data-lj-remove-organiser]');
      var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-lj-card-swatch]'));
      var firstAvailableSwatch = swatches.find(function (swatch) { return !swatch.disabled; });
      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (event) {
          event.stopPropagation();
          if (purchaseInFlight || swatch.disabled) return;
          // The filter describes colours the organiser offers; a manual swatch preview should not clear it.
          updateCardVariant(card, swatch);
          selectOrganiser(selectedOrganiser);
          report('');
        });
      });

      if (firstAvailableSwatch) {
        var initialSwatch = swatches.find(function (swatch) {
          return !swatch.disabled && swatch.classList.contains('is-active');
        }) || firstAvailableSwatch;
        updateCardVariant(card, initialSwatch);
      } else {
        var swatchGroup = card.querySelector('[data-lj-card-swatches]');
        if (swatchGroup) swatchGroup.hidden = true;
      }

      if (addButton) {
        addButton.addEventListener('click', function (event) {
          event.stopPropagation();
          if (purchaseInFlight || !cardIsAvailable(card)) return;
          selectOrganiser(card);
          report('');
          openBundleConfirmation(addButton);
        });
      }

      if (removeButton) {
        removeButton.addEventListener('click', function (event) {
          event.stopPropagation();
          if (purchaseInFlight) return;
          if (selectedOrganiser === card) selectOrganiser(null);
          report('');
        });
      }

      card.addEventListener('click', function (event) {
        if (event.target.closest('[data-lj-card-swatch], [data-lj-card-view], [data-lj-add-bundle], [data-lj-remove-organiser]')) return;
        if (purchaseInFlight || !cardIsAvailable(card) || (addButton && addButton.disabled)) return;
        selectOrganiser(card);
        report('');
        openBundleConfirmation(addButton || event.currentTarget);
      });
    });

    if (refillOnlyButton) {
      refillOnlyButton.addEventListener('click', function () {
        if (purchaseInFlight) return;
        if (!refillVariantId) {
          report('The Lifestyle Journal refill is not available yet.');
          return;
        }

        var quantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
        selectOrganiser(null);
        report('');
        setPurchaseBusy(true, refillOnlyButton);
        postCart([{ id: refillVariantId, quantity: quantity }]).then(function (response) {
          standaloneOffer = standaloneOfferFromResponse(response, refillVariantId, refillPrice, refillTitle);
          organiserBundleOffer = null;
          openModal(modal, 'refill-only');
          notifyCartChanged();
          document.dispatchEvent(new CustomEvent('lj:cart:add', { detail: { refillOnly: true } }));
        }).catch(function (error) {
          report(error.message || 'Unable to add this refill to the basket.');
        }).finally(function () {
          setPurchaseBusy(false, refillOnlyButton);
        });
      });
    }

    if (scrollBuilderButton) {
      scrollBuilderButton.addEventListener('click', function () {
        if (purchaseInFlight || !builder) return;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var scrollTarget = builderTitle || builder;
        scrollTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (builderTitle) {
          window.requestAnimationFrame(function () {
            try {
              builderTitle.focus({ preventScroll: true });
            } catch (_error) {
              builderTitle.focus();
            }
          });
        }
      });
    }

    if (confirmAddButton) {
      confirmAddButton.addEventListener('click', function () {
        if (purchaseInFlight) return;
        if (!refillVariantId) {
          setConfirmStatus('The Lifestyle Journal refill is not available yet.');
          return;
        }
        if (!selectedOrganiser || !cardIsAvailable(selectedOrganiser)) {
          setConfirmStatus('Please select an available organiser colour.');
          return;
        }

        var organiserVariantId = Number(selectedOrganiser.dataset.variantId || 0);
        var organiserPrice = Number(selectedOrganiser.dataset.variantPrice || selectedOrganiser.dataset.price || 0);
        if (!organiserVariantId) {
          setConfirmStatus('Please select an available organiser colour.');
          return;
        }

        var organiserProperties;
        try {
          organiserProperties = organiserPrintProperties(selectedOrganiser, organiserVariantId);
        } catch (error) {
          setConfirmStatus(error.message);
          return;
        }

        var quantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
        var bundleId = 'lj_' + Date.now() + '_' + Math.round(Math.random() * 1000000);
        var refillNow = Math.round(refillPrice * 0.85);
        var bundleWas = organiserPrice + (refillPrice * quantity);
        var bundleNow = organiserPrice + (refillNow * quantity);
        var discount = bundleWas > 0 ? Number((((bundleWas - bundleNow) / bundleWas) * 100).toFixed(4)) : 0;
        var organiserTitle = selectedOrganiser.dataset.title || 'A5 Organiser';

        setConfirmStatus('');
        report('');
        setPurchaseBusy(true, confirmAddButton);
        postCart([
          {
            id: organiserVariantId,
            quantity: 1,
            properties: Object.assign({}, organiserProperties, {
              _bundleId: bundleId,
              _parent: organiserVariantId,
              _role: 'main',
              _discount: discount,
              _orig_cents: organiserPrice,
              _now_cents: organiserPrice,
              _bundle_type: 'lifestyle-journal',
              _bundle_label: refillTitle + ' + ' + organiserTitle
            })
          },
          {
            id: refillVariantId,
            quantity: quantity,
            properties: {
              _bundleId: bundleId,
              _parent: organiserVariantId,
              _role: 'first',
              _discount: discount,
              _orig_cents: refillPrice,
              _now_cents: refillNow,
              _title: refillTitle,
              _bundle_type: 'lifestyle-journal-refill',
              _offer_percent: 15,
              _bundle_parent_variant: String(organiserVariantId),
              _bundle_label: '15% off Lifestyle Journal Refill'
            }
          }
        ]).then(function (response) {
          var responseItems = response && Array.isArray(response.items) ? response.items : [response];
          var responseItem = responseItems.find(function (item) {
            return item && Number(item.id || item.variant_id) === organiserVariantId;
          });
          standaloneOffer = null;
          organiserBundleOffer = {
            bundleId: bundleId,
            lineKey: responseItem && responseItem.key ? String(responseItem.key) : '',
            organiserProperties: organiserProperties,
            organiserVariantId: organiserVariantId,
            organiserPrice: organiserPrice,
            organiserTitle: organiserTitle,
            firstVariantId: refillVariantId,
            firstPrice: refillPrice,
            firstTitle: refillTitle,
            firstQuantity: quantity,
            unitPrice: bundleNow
          };
          closeBundleConfirmation({ restoreFocus: false, keepBodyLocked: !!modal });
          selectOrganiser(null);
          openModal(modal, 'bundle');
          notifyCartChanged();
          document.dispatchEvent(new CustomEvent('lj:cart:add', { detail: { bundleId: bundleId } }));
        }).catch(function (error) {
          setConfirmStatus(error.message || 'Unable to add this bundle to the basket.');
        }).finally(function () {
          setPurchaseBusy(false, confirmAddButton);
        });
      });
    }

    selectOrganiser(null);
    applyFilters(false);
  }

  function init() {
    document.querySelectorAll('[data-lj-page]').forEach(function (root) {
      if (root.hasAttribute('data-lj-bundle')) hydrateBundleJournal(root);
      initQuantity(root);
      initStory(root);
    });
    document.querySelectorAll('[data-lj-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
